/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Injectable, TemplateRef } from "@angular/core";

import { UiModule } from "@webapp/ui/ui.module";
import { NzMessageService } from "ng-zorro-antd/message";
import { UiMessageDataOptions, UiMessageRef } from "@webapp/ui/message/message.models";
import { fillDataOptionsNzValues } from "@webapp/ui/message/util/message.util";

@Injectable({
  providedIn: UiModule,
})
export class UiMessageService extends NzMessageService {
  public success(content: string | TemplateRef<void>, options?: UiMessageDataOptions): UiMessageRef {
    return super.success(content, fillDataOptionsNzValues(options));
  }

  public error(content: string | TemplateRef<void>, options?: UiMessageDataOptions): UiMessageRef {
    return super.error(content, fillDataOptionsNzValues(options));
  }

  public info(content: string | TemplateRef<void>, options?: UiMessageDataOptions): UiMessageRef {
    return super.info(content, fillDataOptionsNzValues(options));
  }

  public warning(content: string | TemplateRef<void>, options?: UiMessageDataOptions): UiMessageRef {
    return super.warning(content, fillDataOptionsNzValues(options));
  }

  public loading(content: string | TemplateRef<void>, options?: UiMessageDataOptions): UiMessageRef {
    return super.loading(content, fillDataOptionsNzValues(options));
  }

  public create(type: "success" | "info" | "warning" | "error" | "loading" | string, content: string | TemplateRef<void>, options?: UiMessageDataOptions): UiMessageRef {
    return super.create(type, content, fillDataOptionsNzValues(options));
  }
}
